import {
    sync
} from '../../../../services/UserService'

/**
 * Set the user preferences object
 *
 * @param  {Function} options.commit
 * @param  {Object} preferences
 * @return {Void}
 */
const setPreferences = ({ commit }, preferences) => {
    commit('SET_PREFERENCES', preferences)
}

/**
 * Update a user's preferences
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Promise}
 */
const syncPreferences = ({ commit }, payload) => {
    sync(payload)
}

/**
 * Update the local pereference
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updateUserPreference = ({ commit }, payload) => {
    commit('UPDATE_LOCAL_PREFERENCE', payload)
}

/**
 * Update the unit/decimal preference
 *
 * @param  {Function} options.commit
 * @param  {Object} payload
 * @return {Void}
 */
const updateCurrencyPreference = ({ commit }, payload) => {
    commit('UPDATE_CURRENCY_PREFERENCE', payload)
}

export default {
    setPreferences,
    syncPreferences,
    updateUserPreference,
    updateCurrencyPreference
}



// WEBPACK FOOTER //
// ./src/state/modules/user/preferences/actions.js